import { Platform } from 'react-native';

export const title = (text) => Platform.select({ web: `Evey Check-In | ${text}`, default: text });
